<template>
  <div class="pa-6">
    <div class="d-flex justify-space-between align-center mb-6">
      <div class="component-title">Kế hoạch nhập học</div>
      <div class="d-flex flex-column align-end" style="gap: 12px">
        <div class="d-flex justify-end" v-if="canConfig" style="gap: 12px">
          <ExcelImport @onRefresh="onRefresh" />
          <ExcelExport />
        </div>
        <DeadlineConfig />
      </div>
    </div>
    <v-card class="pa-6 elevation-1 mb-6">
      <DocumentFilter @onFilterChanged="onFilterChanged" />
    </v-card>
    <v-card class="elevation-1">
      <DocumentTable ref="documentTable" />
    </v-card>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import DocumentFilter from './ListFilter.vue'
import DocumentTable from './ListTable.vue'
import ExcelImport from './excel-import/index.vue'
import ExcelExport from './ExcelExport.vue'
import DeadlineConfig from './deadline-config/index.vue'
export default {
  components: {DocumentFilter, DocumentTable, ExcelImport, DeadlineConfig, ExcelExport},
  computed: {
    ...mapGetters('auth', ['user']),
    canConfig() {
      return this.$helpers.ALLOWED_SETTING_ENROLL_PLAN.includes(this.user.username)
    },
  },
  async mounted() {
    let query = {fromAdmin: true, adminQueryType: 'enrollPlan'}
    if (this.user.department === 'both') query.department_in = ['Cơ sở A', 'Cơ sở 1', 'unset']
    else query.department_in = [this.user.department, 'unset']
    await this.countItems(query)
  },
  methods: {
    ...mapActions({fetchItems: 'cv/fetchCVs', countItems: 'cv/countCVs', resetState: 'cv/reset'}),
    async onFilterChanged(data) {
      this.$loading.active = true
      const params = {...data, fromAdmin: true, adminQueryType: 'enrollPlan'}
      await this.fetchItems({...params, _start: 0, _limit: 10})
      await this.countItems(params)
      this.$loading.active = false
    },
    onRefresh() {
      this.$refs['documentTable'].refresh()
    },
  },
  async beforeDestroy() {
    await this.resetState()
  },
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
